import { CircularProgress } from '@mui/material'
import { GET_DASHBOARD_PROMOTION, getPromotion } from 'api'
import clsx from 'clsx'
import {
	Box,
	Button,
	GroupButton,
	Modal,
	SendNotificationModal,
	TitleBox
} from 'components'
import { useToast } from 'hooks'
import { BoxComponentProps, Icons } from 'interfaces'
import QRCode from 'qrcode.react'
import React, { useCallback, useState } from 'react'
import { useQuery } from 'react-query'
import Cookies from 'universal-cookie'
import { AllAboard, MoveOver, SSO } from './tabsPromotion'

interface ButtonOptions {
	name: string
	value: string
	icon?: string
	disabled?: boolean
}

export const Promotion: React.FC<BoxComponentProps> = ({
	styles
}): JSX.Element => {
	const { showToast } = useToast()
	const cookies = new Cookies()
	const userId = cookies.get('userId')
	const [open, setOpen] = useState(false)
	const [qrCode, setQrCode] = useState('')
	const organizationId = cookies.get('organization_id')
	const [sendNotificationModal, setSendNotificationModal] = useState(false)
	const { data, isLoading } = useQuery(
		[GET_DASHBOARD_PROMOTION, userId, organizationId],
		() => getPromotion(organizationId)
	)

	const tabs: ButtonOptions[] = [
		{
			value: '0',
			name: 'All Aboard!',
			icon: Icons.train
		},
		{
			value: '1',
			name: 'Move Over',
			icon: Icons.trolley,
			disabled: !data?.move_over
		},
		{
			value: '2',
			name: 'SSO',
			icon: Icons.key,
			disabled: data?.sso === null
		}
	]
	const [currentTab, setCurrentTab] = useState(tabs[0].value)

	const handleCopy = useCallback((url: string): void => {
		if (url) {
			navigator.clipboard.writeText(url).then(() => {
				showToast('Success', 'Link copied to clipboard.', 'success')
			})
		}
	}, [])

	const downloadQRCode = (): void => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const qrCodeFuntiion = document.getElementById('qrCode') as any
		if (qrCode) {
			const qrCodeURL = qrCodeFuntiion
				.toDataURL('image/png')
				.replace('image/png', 'image/octet-stream')
			const aEl = document.createElement('a')
			aEl.href = qrCodeURL
			aEl.download = 'QR_Code.png'
			document.body.appendChild(aEl)
			aEl.click()
			document.body.removeChild(aEl)
			setOpen(false)
		}
	}

	const handleNewRequest = (): void => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const win = window as any
		if (win?.zE) {
			win.zE.activate()
		}
	}

	return (
		<div className={clsx('relative', styles)}>
			<TitleBox title="Promotion" icon={Icons.share} className="mb-4" />
			<Box className="flex flex-col gap-3 w-full h-[320px] py-6 px-6">
				<>
					{isLoading ? (
						<div className="flex items-center justify-center w-full h-[200px] py-2 px-1 ">
							<CircularProgress disableShrink />
						</div>
					) : (
						<>
							<div className="!flex !justify-between">
								<GroupButton
									period={currentTab}
									setPeriod={setCurrentTab}
									options={tabs.filter(option => !option.disabled)}
									className="!w-full"
									containerOptionsClassName="py-2 !sm:gap-0 2xl:gap-10"
								/>
							</div>
							{currentTab === '0' && (
								<AllAboard
									setOpen={setOpen}
									setQrCode={setQrCode}
									url={data?.all_aboard}
									handleNewRequest={handleNewRequest}
									setSendNotificationModal={setSendNotificationModal}
									handleCopy={() => handleCopy(data?.all_aboard || '')}
								/>
							)}
							{currentTab === '1' && (
								<MoveOver
									setOpen={setOpen}
									url={data?.move_over}
									setQrCode={setQrCode}
									handleCopy={() => handleCopy(data?.move_over || '')}
								/>
							)}
							{currentTab === '2' && (
								<SSO
									url={data?.sso}
									setOpen={setOpen}
									setQrCode={setQrCode}
									handleNewRequest={handleNewRequest}
									handleCopy={() => handleCopy(data?.sso || '')}
								/>
							)}
							{sendNotificationModal && (
								<SendNotificationModal
									open={sendNotificationModal}
									setOpen={setSendNotificationModal}
								/>
							)}
						</>
					)}
					<Modal
						setOpen={setOpen}
						open={open}
						type="normal"
						closeButton
						title="Actions"
						colorIcon="text-[#17B3C5] w-[14px]"
						borderIcon="border-[#17B3C5] p-[2px]"
						sizeModal="w-[326px] h-[330px] p-2"
						marginL
					>
						<div className="flex flex-col items-center  ">
							<div className="my-3">
								<QRCode
									size={256}
									id="qrCode"
									value={qrCode}
									viewBox="0 0 256 256"
									style={{ height: '214px', maxWidth: '214px', width: '214px' }}
								/>
							</div>
							<Button
								label="Confirm Download"
								className="!min-w-[unset] !py-[9px] w-[224px] mt-2"
								onClick={() => downloadQRCode()}
							/>
						</div>
					</Modal>
				</>
			</Box>
		</div>
	)
}
